import { ChiptaElement, html, css } from 'chipta-libs/main.js';
import { sendContactMessage } from 'chipta-libs/api/contact.js';
import 'chipta-libs/components/styled-button.js';
import { formStyles } from 'styles/form.js';


export default class ContactForm extends formStyles(ChiptaElement) {

  static get properties() {
    return {
      messageSent: { type: Boolean }
    };
  }

  render() {
    if (this.messageSent) {
      return this.messageSentView;
    } else {
      return this.contactForm;
    }
  }

  get contactForm() {

    return html`

      <form @submit=${this.handleSubmit}>

        <label class="field">
          <div class="label">${gettext('name')}</div>
          <div class="input">
            <input
              id="name"
              type="text"
              minlength="2"
              required
              ?disabled=${this.messageSent}
            >
          </div>
        </label>

        <label class="field">
          <div class="label">${gettext('email')}</div>
          <div class="input">
            <input
              id="email"
              type="email"
              required
              ?disabled=${this.messageSent}
            >
          </div>
        </label>

        <label class="field">
          <div class="label">${gettext('message')}</div>
          <div class="input">
            <textarea
              id="message"
              rows="5"
              minlength="4"
              required
              ?disabled=${this.messageSent}
            ></textarea>
          </div>
        </label>

        ${''/*
        <div class="form-group">

            <span class="field-label" for="user">Ik ben een</span>
            <label class="chipta-radio u-db">
                <input type="radio" name="user" checked>
                <span></span>
                <span>Gebruiker</span>
            </label>

            <label class="chipta-radio u-db">
                <input type="radio" name="user">
                <span></span>
                <span>Organizator</span>
            </label>

        </div>
        */}

        <styled-button type="secondary">
          <button type="submit">Send</button>
        </styled-button>

        ${this.messageSentMessage}

      </form>

    `;

  }

  get messageSentView() {

    if (!this.messageSent) {
      return;
    }

    return html`

      <h4>${gettext('thank_you_for_your_message')}</h4>
      <p>${gettext('b2b_form_send_message_response')}</p>

      <styled-button type="secondary">
        <button @click=${this.handleClickRestartButton}>
          ${gettext('send_another_message')}
        </button>
      </styled-button>

    `;

  }

  static get styles() {

    return css`
      h4 {
        color: white;
      }
    `;

  }

  handleSubmit(event) {

    event.preventDefault();

    const data = {
      name: this.el('#name').value,
      email: this.el('#email').value,
      message: this.el('#message').value,
    };

    sendContactMessage(data).then(response => {
      console.log('message sent successfully!', response);
      this.messageSent = true;
    }).catch(error => {
      console.log('error sending message:', error);
    });

  }

  handleClickRestartButton() {
    this.messageSent = false;
  }

}

customElements.define('contact-form', ContactForm);
